import { StateSchema } from '@/shared/types/store';

export const getMyProfile = (state: StateSchema) => state.profile.data;
